import { withRouter } from 'react-router-dom'
import styles from './Section.css'
import { HyperLink } from '../../Form'

const Section = props => {
  const {
    anchor = {},
    component: Component,
    minHeight = 300,
    ...restProps
  } = props
  const {
    link,
    linkTitle
  } = anchor
  return (
    <>
      <p id={link}>
        <HyperLink
          className={styles.title}
          href={`#${link}`}
        >
          {linkTitle}
        </HyperLink>
      </p>
      <div style={{ minHeight }}>
        <Component {...restProps} />
      </div>
    </>
  )
}

export default withRouter(Section)
